import Tooltip from './tooltip.vue';

export default Tooltip;


// WEBPACK FOOTER //
// ./src/components/tooltip/index.js